// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-radio[data-v-fd86ad4c] .col-12 {\r\n  padding: 0 !important;\n}\n.custom-font[data-v-fd86ad4c] {\r\n  color: #727272;\r\n  font-size: 14px;\n}\n[data-v-fd86ad4c] .custom-datetime-picker-container {\r\n  width: 100% !important;\ninput[type='text'][data-v-fd86ad4c] {\r\n    width: 100%;\n}\n}\r\n", ""]);
// Exports
module.exports = exports;
